import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchAgreementCustomers,
  fetchServiceRecords,
} from "../../slices/apps/agreementSlice";

// sayfalar, modallar vb.
import ServiceRecordTable from "./ServiceRecordTable";

const ServiceRecords = () => {
  const dispatch = useDispatch();

  const { serviceRecordsRefresh, agreementCustomersRefresh } = useSelector(
    (state) => {
      return {
        serviceRecordsRefresh: state.agreement.serviceRecordsRefresh,
        agreementCustomersRefresh: state.agreement.agreementCustomersRefresh,
      };
    },
    shallowEqual
  );

  const fetchData = async () => {
    try {
      await dispatch(fetchServiceRecords());
      await dispatch(fetchAgreementCustomers());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, serviceRecordsRefresh, agreementCustomersRefresh]);

  document.title = "Hizmet Kayıtları | Global Yol Yardım";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xxl={12}>
              <ServiceRecordTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ServiceRecords;
